﻿import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import theme from "./Checkbox.module.sass";

const SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};

const Checkbox = forwardRef(({ size = SIZES.medium, error, ...others }, ref) => (
  <div
    className={classNames(theme.Checkbox, theme[size], {
      [theme.InputError]: error,
    })}
  >
    <input className={theme[size]} type="checkbox" {...others} ref={ref} />
    <span className={classNames(theme.OuterBox, theme[size])} />
    <span className={classNames(theme.InnerBox, theme[size])} />
    {error && <span className={theme.ErrorText}>{error}</span>}
  </div>
));

Checkbox.displayName = 'Checkbox';

Checkbox.propTypes = {
  size: PropTypes.string,
  error: PropTypes.string,
  register: PropTypes.func,
};

export default Checkbox;
